import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';
import { setMeasurementHistoryInfo } from '@store/actions/MeasurementAction';
import { Types } from '@store/types';

import { fetchMeasurementHistoryByHistoryId } from '@services/measurementService';

import { onGetLocalFromUtc } from '@utils/Util';

const ViewHistory = ({ historyList, handleCurrentVersion, onRestoreHistory }) => {
	const dispatch = useDispatch();
	const [selectedHistoryId, setSelectedHistoryId] = useState(null);

	const onClickPreview = async (historyId) => {
		try {
			dispatch(openLoader());
			const data = await fetchMeasurementHistoryByHistoryId(historyId);
			dispatch({
				type: Types.FETCH_PRODUCT_MEASUREMENT_TABLE_DATA,
				payload: data?.changeLog?.tableData || []
			});
			dispatch(
				setMeasurementHistoryInfo({
					id: data.id,
					numberOfChange: data.numberOfChange,
					createdUserName: data.createdUserName,
					createdAt: data.createdAt
				})
			);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	const renderHistoryInfo = () => {
		return historyList?.map((item) => {
			return (
				<div
					className={`single-history d-flex ${selectedHistoryId === item.id ? 'selected' : ''}`}
					key={`single_history_${item.id}`}
				>
					<div className="profile">
						{item.profilePicUrl && <img src={item.profilePicUrl} alt="profile" />}
						{!item.profilePicUrl && (
							<img src={`${process.env.PUBLIC_URL}/images/pro_pic_default.svg`} alt="profile" />
						)}
					</div>
					<div className="history-info w-100">
						<div className="d-flex align-items-center justify-content-between">
							<p className="regular-14 weight-500">{item.createdUserName}</p>
							<p className="regular-12 gray_dark_03">
								{onGetLocalFromUtc(item?.createdAt, 'MMM DD, YYYY')} -{' '}
								{onGetLocalFromUtc(item?.createdAt, 'h:mm a')}
							</p>
						</div>
						<div className="d-flex align-items-center mt-1">
							<p
								className="regular-14 blue cursor-pointer"
								onClick={() => {
									onClickPreview(item.id);
									setSelectedHistoryId(item?.id);
								}}
							>
								Preview{' '}
							</p>
							<p className="regular-10 gray_dark_01 mx-2">|</p>
							<p
								className="regular-14 blue cursor-pointer"
								onClick={() => {
									setSelectedHistoryId(item?.id);
									onRestoreHistory(item.id);
								}}
							>
								Restore{' '}
							</p>
							<p className="regular-10 gray_dark_01 mx-2">|</p>
							<p className="regular-14 gray_dark_01">
								{item.numberOfChange > 1
									? `${item.numberOfChange} changes`
									: `${item.numberOfChange} change`}{' '}
							</p>
						</div>
					</div>
				</div>
			);
		});
	};

	return (
		<div className="measurement-history-sidebar">
			<div className="d-flex align-items-center justify-content-between px-4 py-3 border-bottom-solid">
				<h3 className="regular-16 weight-500 mb-0">View History</h3>
				<img
					src={`${process.env.PUBLIC_URL}/icons/close.svg`}
					alt="close"
					className="cursor-pointer"
					onClick={handleCurrentVersion}
				/>
			</div>
			<div className="all-history scroll-y-label">{renderHistoryInfo()}</div>
		</div>
	);
};

export default ViewHistory;
